import React from "react";
import { Button, InputNumber } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const QuantityStepper = ({
  value = 0,
  min,
  max,
  onDecrease,
  onIncrease,
  onChange,
  showInput = false,
  disabled = false,
  decreaseDisabled = false,
  increaseDisabled = false,
  className = "",
}) => {
  const isDecreaseDisabled = disabled || decreaseDisabled || (min !== undefined && Number(value) <= Number(min));
  const isIncreaseDisabled = disabled || increaseDisabled || (max !== undefined && Number(value) >= Number(max));

  return (
    <div
      className={`app-quantity-stepper ${className}`.trim()}
      data-allow-rapid-action="true"
    >
      <Button
        type="default"
        htmlType="button"
        className="app-quantity-stepper__button"
        icon={<MinusOutlined />}
        disabled={isDecreaseDisabled}
        onClick={() => !isDecreaseDisabled && onDecrease?.()}
      />
      {showInput ? (
        <InputNumber
          min={min}
          max={max}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      ) : (
        <span className="app-quantity-stepper__value">{value}</span>
      )}
      <Button
        type="default"
        htmlType="button"
        className="app-quantity-stepper__button"
        icon={<PlusOutlined />}
        disabled={isIncreaseDisabled}
        onClick={() => !isIncreaseDisabled && onIncrease?.()}
      />
    </div>
  );
};

export default QuantityStepper;
